<template>
  <div class="columns is-tabled is-multiline is-centered">
    <div class="column is-one-third" v-for="work in list" :key="work.name">
      <div class="work" @click="showModal(work)">
        <figure class="image">
          <img :src="require(`@/assets/work/${work.thumb}`)" :alt="work.name" />
        </figure>
        <div class="work-info">
          <div class="work-info-text">
            <strong>{{ work.type }}</strong>
            <br />
            <span>{{ work.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <b-modal :active.sync="isModalActive" :width="720" scroll="keep">
      <div class="card">
        <div class="card-image" v-if="dataModal.photo || dataModal.video">
          <figure class="image">
            <img
              :src="require(`@/assets/work/popup/${dataModal.photo}`)"
              :alt="dataModal.name"
              v-if="!dataModal.video"
            />
            <video-player
              v-if="dataModal.video"
              :options="dataModal.videoOptions"
              class="vjs-default-skin vjs-big-play-centered"
            />
          </figure>
        </div>
        <div class="card-content">
          <div class="content">
            <h5>
              <strong>{{ dataModal.name }}</strong> / {{ dataModal.type }}
            </h5>
            <ul>
              <li v-for="item in dataModal.tasks" :key="item">
                {{ item }}
              </li>
            </ul>
            <div v-html="dataModal.info"></div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// https://github.com/codrops/DirectionAwareHoverEffect
import list from "@/data/work.json";
import VideoPlayer from "@/components/VideoPlayer.vue";

export default {
  name: "Work",
  components: {
    VideoPlayer
  },
  data() {
    return {
      list: list,
      isModalActive: false,
      dataModal: {}
    };
  },
  methods: {
    showModal: function(work) {
      this.isModalActive = true;
      if (work.video) {
        work.videoOptions = {
          poster: require(`@/assets/videos/${work.photo}`),
          // poster: require(`@/assets/work/popup/${work.photo}`),
          sources: [
            {
              src: require(`@/assets/videos/${work.video}`),
              type: "video/mp4"
            }
          ]
        };
      }
      this.dataModal = work;
    }
  }
};
</script>

<style scoped lang="scss">
.card {
  .card-content {
    text-align: left;
    padding: 3rem 1.5rem;

    ul {
      list-style: none;

      li::before {
        content: "\2022";
        color: inherit;
        font-weight: normal;
        display: inline-block;
        width: 1em;
        margin-left: -1em;
      }
    }

    h5 {
      font-weight: normal;
      color: #000;
      strong {
        font-weight: bold;
      }
    }
  }
}

.work {
  cursor: pointer;
  position: relative;
  width: 320px;
  margin: 0 auto;
  overflow: hidden;

  &:hover {
    .work-info {
      top: 0;
    }
  }

  .work-info {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #000;
    color: #fff;
    top: 100%;
    left: 0;
    transition: top 300ms ease;

    .work-info-text {
      text-align: left;
      position: absolute;
      bottom: 0;
      padding: 2rem 1.5rem;
      color: #fff;

      strong {
        font-weight: bold;
        color: #f7d500;
        text-transform: uppercase;
      }
    }
  }
}
</style>
